import React from "react";

export const Testimonials = (props) => {
  const address = "R. Adolfo Gustavo, 403 - Serraria, Maceió - AL, 57045-340";
  const mapSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3933.8141709057204!2d-35.7211157!3d-9.6112637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x701461371116eef%3A0xc35f14d1933a70f9!2sR.%20Adolfo%20Gustavo%2C%20403%20-%20Serraria%2C%20Macei%C3%B3%20-%20AL%2C%2057045-340!5e0!3m2!1spt-BR!2sbr!4v1767638455048!5m2!1spt-BR!2sbr";

  return (
    <div id="maps" style={{ backgroundColor: '#fff' }}>

      <div className="container-fluid p-0"> {/* container-fluid ocupa 100% */}
        <div className="row">
          <div className="col-12">
            <div className="section-title text-center pt-4 pb-2">
              <b><p className="mb-4">{address}</p></b> 
            </div>
            <div className="map-container">
              <iframe 
                src={mapSrc}
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Maps - Our Location"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};